export const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3110";

export const unwrapSettings = (response) => {
  if (Array.isArray(response)) return response[0] || null;
  return response || null;
};

export const isExternalURL = (url) => {
  if (!url) return false;

  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

export const resolveMediaUrl = (url, fallback = "/img/placeholder.jpg") => {
  if (!url) return fallback;
  if (String(url).startsWith("data:")) return url;
  if (isExternalURL(url)) return url;

  const cleanBase = BASE_URL.replace(/\/$/, "");
  const cleanPath = String(url).startsWith("/") ? url : `/${url}`;

  return `${cleanBase}${cleanPath}`;
};

export const stripHtml = (html = "") =>
  String(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/\s+/g, " ")
    .trim();

export const truncateText = (value = "", max = 160) => {
  const clean = stripHtml(value);
  if (clean.length <= max) return clean;
  return `${clean.slice(0, max).trim()}...`;
};

export const formatDateFR = (date) => {
  if (!date) return "Date à venir";

  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "Date à venir";

  return d.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};